const restApiStage = "https://01pnkkxr74.execute-api.us-east-1.amazonaws.com/v1/";
const restApiDev   = "https://pw69tk3yk3.execute-api.us-east-1.amazonaws.com/v1/";
const restApiTest  = "https://qbjuec61s8.execute-api.us-east-1.amazonaws.com/v1/";

const apiMap = {
    "test": restApiTest,
    "dev": restApiDev,
    "stage": restApiStage,
};

console.log("* ==> process.env.REACT_APP_AIIG_BACKEND_ENV: ", process.env.REACT_APP_AIIG_BACKEND_ENV);
const restApiBase = apiMap[process.env.REACT_APP_AIIG_BACKEND_ENV] || restApiStage;

console.log("* ==> restApiBase:", restApiBase);

export { restApiBase,restApiDev, restApiStage, restApiTest};
